'use client'
import React, { ReactElement, ReactNode } from 'react'

interface ContentWrapperProps {
    children: ReactNode
    notMain?: boolean
}
export const ContentWrapper = ({ children, notMain }: ContentWrapperProps): ReactElement => {
    const classes = 'o-layout'
    if (!!notMain) {
        return <div className={classes}>{children}</div>
    }
    return <main className={classes}>{children}</main>
}
